/**
 * Interview-scheduling dialog storage.
 *
 * Keyed by user id, because `auth_purge` clears only the per-tab scope on a sign-in change -- a bare
 * flag in localStorage would hide the notice from the next person to sign in on a shared browser.
 */
import Storage from '../index';
import StorageKeys from '../keys';

const readDismissed = () => Storage.get(StorageKeys.schedulingDefaultAvailabilityNoticeDismissed, {}) || {};

const scheduling = {
    isDefaultAvailabilityNoticeDismissed: (userId) => Boolean(readDismissed()[userId]),

    dismissDefaultAvailabilityNotice: (userId) =>
        Storage.set(StorageKeys.schedulingDefaultAvailabilityNoticeDismissed,
                    { ...readDismissed(), [userId]: true }),
};

export default scheduling;
